import { useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';

import type { MeetingContextAnswer } from '@/app/queries/MeetingContextQuery/fetchMeetingContext';
import { meetingContextQuery } from '@/app/queries/MeetingContextQuery/useMeetingCopy';

type MeetingAppointment = Omit<MeetingContextAnswer, 'context'>;

// Until the context answers, or when it has nothing to say, the visit has no
// known time and is not cancelled.
const NO_APPOINTMENT: MeetingAppointment = {
  appointmentStart: null,
  isCancelled: false,
  currentMeetingUrl: null,
};

const useMeetingAppointment = (): MeetingAppointment => {
  const { hash } = useParams<{ hash: string }>();
  const { data } = useQuery(meetingContextQuery(hash!));

  return data ?? NO_APPOINTMENT;
};

export default useMeetingAppointment;
